var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"locationField"}},[_c('input',{ref:"autocompleteRef",staticClass:"search-location",attrs:{"id":"autocomplete","placeholder":"Enter your address","type":"text"}})])}
var staticRenderFns = []

export { render, staticRenderFns }